import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, watch } from 'vue';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    
    import axios from 'axios';
    import DataTableSelect from '@/components/datatable/DataTableSelect.vue';
    
    import type { AcceptableValue } from 'reka-ui';
    import type { DataTableSelectOption, DashboardTableData } from '@/types';
    import type { Row } from '@tanstack/vue-table';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TableStatusSelect',
  props: {
    options: {},
    row: {},
    columnId: {},
    reportingPeriod: {},
    selectedGrouping: {}
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();

    const currentValue = ref(props.row.original[props.columnId] as AcceptableValue);
    

    const routeName = computed(() => {
        return props.columnId === 'vat_status'
            ? 'v2.dashboard.vat.update'
            : 'v2.dashboard.status.update';
    });

    const handleStatusChange = async (newValue: AcceptableValue) => {
        const previousValue = currentValue.value;

        try {
            const selectedOption = props.options.find((opt) => opt.value === newValue);
            if (!selectedOption) return;

            currentValue.value = newValue;

            await axios.post(route(routeName.value), {
                company_id: props.row.original.id,
                data_field_id: selectedOption.value,
                data_field_group: props.columnId,
                data_field_approve: selectedOption.addon,
                reporting_period: props.reportingPeriod,
            });

            // Update local row original so UI remains consistent without refetch
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            (props.row.original as any)[props.columnId] = selectedOption.value as any;

            if (props.columnId === 'pbc_status' && selectedOption.color === 'green') {
                await axios.post(
                    route('v2.dashboard.pbc-deadline.update', { company: props.row.original.id }),
                    {
                        reporting_period: props.reportingPeriod,
                        deadline: null,
                    },
                );

                // Reflect pbc_deadline locally too
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                (props.row.original as any)['pbc_deadline'] = null;
            }
        } catch (error) {
            currentValue.value = previousValue;
            console.error('Failed to update status:', error);
            toast.error(t('dashboards.status_update_failed'));
        }
    };

    

    // Keep local model in sync if outer data changes (e.g., details hydration or other edits)
    watch(
        () => props.row.original[props.columnId],
        (val) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            currentValue.value = val as AcceptableValue;
        },
    );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableSelect, {
    "model-value": currentValue.value,
    options: _ctx.options,
    "onUpdate:modelValue": handleStatusChange
  }, null, 8, ["model-value", "options"]))
}
}

})